import React, { Component } from "react";
import {
  Button,
  RadioButtonGroup,
  RadioButton,
  TextInput
} from "carbon-components-react";
import axios from "axios";
import CountrySelection from "../common/CountrySelection";
import { notifyError, notifySuccess } from "../common/notification/NotificationHelper";
import Spinner from "../common/spinner/Spinner";

import Select from "carbon-components-react/lib/components/Select";
import SelectItem from "carbon-components-react/lib/components/SelectItem";


class NotifyUsers extends Component {
  constructor(props) {
    super(props);

    this.sendMailCredentials = this.sendMailCredentials.bind(this);
    this.handleRadioClick = this.handleRadioClick.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onHandleEmailChange = this.onHandleEmailChange.bind(this);
    this.handleResetPassword = this.handleResetPassword.bind(this);
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
  }
  state = { send: "all", resetting: false, email: null, country: null, year: "2015" };

  sendMailCredentials() {
    let data;

    let sendOption = this.state.send;

    if (sendOption === "all") {
      data = {
        send_to_all: "true"
      };
    } else if (sendOption === "single") {
      let email = this.state.email;
      data = { email_list: [email] };
    } else {
      let country = this.state.country;
      data = { send_to_country: country };
    }


    axios.post("/api/mailcredentials/", data).then(response => {
      //console.log("PWD generated");
      if(response.status === 200)
        notifySuccess("Email notification sent!");
      else
        notifyError("Error sending email. Please try again.")  
    });
  }

  handleResetPassword() {
    this.setState({resetting: true});

    let data;

    data = {year: this.state.year}

    axios.post("/api/load_test_data/", data).then(response => {
      //console.log("PWD generated");

      this.setState({resetting: false});

      if(response.status === 200)
        notifySuccess("Data created!");
      else
        notifyError("Error creating data.")  
    });    
  }

  handleRadioClick(e) {
    this.setState({ send: e.target.value });
  }

  onSelectionChanged(selectedValue) {
    this.setState({ country: selectedValue });
  }

  onHandleEmailChange(e) {
    this.setState({ email: e.target.value });
  }

  handleSelectionChange(event) {
    this.setState({ year: event.target.value});
  }


  render() {
    let countrySelection =
      this.state.send === "country" ? (
        <React.Fragment>
          <div className="row">
            <div style={{ padding: "15px" }}>
              <CountrySelection onSelectionChanged={this.onSelectionChanged} />
            </div>
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment />
      );

    let emailSelection =
      this.state.send === "single" ? (
        <React.Fragment>
          <div className="row">
            <div style={{ padding: "15px" }}>
              <TextInput
                id="email"
                name="email"
                // className="input-1671b"
                style={{ width: "420px" }}
                labelText="Email:"
                onChange={this.onHandleEmailChange}
              />
            </div>
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment />
      );

    return (
      <div style={{ height: "calc(100vh - 163px" }}>
        <div id="content-wrapper" className="content-wrapper">
          <div style={{ marginBottom: "15px" }}>
            <div className="page-header">
              <div className="page-header-left">
                <h1 className="page-header-title">
                  Select option for sending notification to NSO focal points
                </h1>
              </div>
            </div>
            <div className="row">
              <div
                className="col-sm-12"
                style={{ textAlign: "justify", fontSize: "16px" }}
              >
                This action will send an email with username and password to
                selected NSO focal points
              </div>
            </div>
          </div>
          <div className="box">
            <div className="box-body">
              <div className="row">
                <RadioButtonGroup name="send-nso" valueSelected="all">
                  <RadioButton
                    name="all"
                    value="all"
                    labelText="Send to all NSO focal points"
                    onClick={this.handleRadioClick}
                  />
                  <RadioButton
                    name="country"
                    labelText="Send to NSO focal points in selected country"
                    value="country"
                    onClick={this.handleRadioClick}
                  />
                  <RadioButton
                    name="single"
                    value="single"
                    labelText="Send to single NSO focal point"
                    onClick={this.handleRadioClick}
                  />
                </RadioButtonGroup>
              </div>
              {countrySelection}
              {emailSelection}

              <div className="row" style={{ marginTop: "15px" }}>
                <Button
                  onClick={this.sendMailCredentials}
                  style={{ padding: "15px" }}
                >
                  Send email notification
                </Button>
              </div>
              <div className="row" style={{ marginTop: "15px" }}>
                {/* <Button
                  onClick={this.handleResetPassword}
                  style={{ padding: "15px" }}
                  disabled={this.state.resetting}
                >
                  Reset password for NSO users (testing phase only) {this.state.resetting? <Spinner />: null}
                </Button> */}
                <Button
                  onClick={this.handleResetPassword}
                  style={{ padding: "15px" }}
                  disabled={this.state.resetting}
                >
                  Add Data For previous years {this.state.resetting? <Spinner />: null}
                </Button>
                <Select
                  id="yearSelection"
                  defaultValue="placeholder-item"
                  onChange={this.handleSelectionChange}
                >
                  <SelectItem key={2015} value="2015" text="2015" />
                  <SelectItem key={2016} value="2016" text="2016" />
                  <SelectItem key={2017} value="2017" text="2017" />
                  <SelectItem key={2018} value="2018" text="2018" />
                  <SelectItem key={2019} value="2019" text="2019" />
                  <SelectItem key={2020} value="2020" text="2020" />
                  <SelectItem key={2020} value="2021" text="2020" />
                  <SelectItem key={2020} value="2022" text="2020" />
                  <SelectItem key={2020} value="2023" text="2020" />
                  <SelectItem key={2020} value="2024" text="2020" />
                  <SelectItem key={2020} value="2025" text="2020" />
                </Select>
              </div>              
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NotifyUsers;
